import Gallery from '@browniebroke/gatsby-image-gallery';
import styled from '@emotion/styled';
import TreeItem from '@mui/lab/TreeItem';
import TreeView from '@mui/lab/TreeView';
import React from 'react';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';
import { BlockHero, Section } from './ContentBlocks';

const CssTreeItem = styled(TreeItem)(
  () => `
    .MuiTreeItem-content {
      flex-direction: row-reverse;
      padding: 0;
    }
    .MuiTreeItem-label {
      padding: 0;
    }
    .MuiCollapse-root {
      margin-top: 0;
    }
    .MuiTreeItem-content.Mui-selected:hover {
      background-color: unset;
    }
    .MuiTreeItem-content.Mui-selected {
      background-color: unset;
    }
    .MuiTreeItem-content.Mui-selected.Mui-focused {
      background-color: unset;
    }
    .MuiTreeItem-content:hover {
      background-color: unset;
    }
    .MuiTreeItem-iconContainer {
      width:0;
      display: none;
    }
  `
);

export const DisclosureSection = ({ section }: { section: Section }) => {
  const [expanded, setExpanded] = React.useState(['0']);
  const handleToggle = (event, nodeIds) => {
    if (nodeIds.length > 0) {
      setExpanded([nodeIds[0]]);
    } else {
      setExpanded([]);
    }
  };

  return (
    <TreeView
      expanded={expanded}
      onNodeToggle={handleToggle}
      className="w-full rounded-2xl py-2"
    >
      {section.blocks.map((b, index) => (
        <CssTreeItem
          key={`${b.heading}_${index}`}
          nodeId={`${index}`}
          className="prose"
          label={
            <h3 className="my-1 flex w-full items-center justify-between rounded-lg bg-primary-100 p-2 text-left text-sm font-medium text-primary-900 hover:bg-primary-200">
              {b.heading}
              {b.subheading ? ` - ${b.subheading}` : ''}
              {expanded.includes(String(index)) ? (
                <FiChevronDown className="text-lg text-primary-500" />
              ) : (
                <FiChevronRight className="text-lg text-primary-500" />
              )}
            </h3>
          }
        >
          <BlockHero block={b} />
          <div
            dangerouslySetInnerHTML={{
              __html: b.body.childMarkdownRemark.html,
            }}
          />
          <div className="mx-4">
            <Gallery images={b.galleryImages} />
          </div>
        </CssTreeItem>
      ))}
    </TreeView>
  );
};
